import PropTypes from 'prop-types';
import React from 'react';
import SplitPayment from '../containers/SplitPayment';
import Modal from '../../Modal';
import CashButton from '../../cashPay/CashButton';

const RefundModalSplit = ({
  on,
  off,
  isOn,
  onMaxClick,
  close,
  ...props
}) => (
  <Modal title="Choose refund amount" close={close} showCloseButton>
    <div className="u-p">
      <div className="layout layout--auto layout--center layout--small u-mb">
        <div className="layout__item u-1/5">
          <CashButton onClick={onMaxClick}>Full</CashButton>
        </div>
        <div className="layout__item u-1/5">
          <CashButton onClick={on} active={isOn}>Custom</CashButton>
        </div>
      </div>
    </div>

    <SplitPayment
      {...props}
      close={off}
      display-if={isOn}
    />
  </Modal>
);
RefundModalSplit.propTypes = {
  on: PropTypes.func.isRequired,
  off: PropTypes.func.isRequired,
  isOn: PropTypes.bool.isRequired,
  onMaxClick: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
};

export default RefundModalSplit;
